import { BACKOFFICE_MODULES, PERMISSION_TYPE_IDS } from 'types/configuration.types';
import { getNudosData } from './getNudosData';

export const getPermissionsByModule = ({ moduleName }: { moduleName: BACKOFFICE_MODULES }) => {
  const loggedUserData = getNudosData();
  const userModulePermissions = loggedUserData?.permissions?.permissions;
  const hasPermission = userModulePermissions?.[moduleName];
  return {
    read: !!hasPermission?.includes(PERMISSION_TYPE_IDS.VIEW),
    edit: !!hasPermission?.includes(PERMISSION_TYPE_IDS.EDIT)
  };
};

export const canSendCustomerChatMessages = (): boolean => {
  return getPermissionsByModule({ moduleName: BACKOFFICE_MODULES.CUSTOMER_CHAT }).edit;
};
